import * as yup from 'yup';

const sessionTypeModalFormValidation = yup.object().shape({
  sessionType: yup.string().trim().required('Session type is a required field'),

});
export default sessionTypeModalFormValidation;
